export function getUrls() {
  // For local development, use staging API
  // For production/preview, use the appropriate API URL
  const apiBase =
    process.env.NEXT_PUBLIC_ZAPIER_BASE_URL || "https://zapier-staging.com";

  return {
    apiBase,
  };
}

export function getTicketCopilotBaseUrl() {
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:9658";
  }
  return "https://ticketcopilot.zapier.com";
}
